import Api from './api'

export default {
    recentlyVisited() {
        let local = JSON.parse(window.localStorage.getItem("recently-visited") ?? "[]");
        let sorted = local.sort((a, b) => b.sort - a.sort);
        let post = [];
        sorted.forEach((item, index) => {
            if (index < 6) {
                post.push(item);
            }
        });
        return Api()
            .post('/api/recently-visited', post, {
                headers: {
                    "Content-Type": "application/json"
                }
            })
            .then((response) => response.data)
    },
}
